<template>
  <div class="card-container" data-test="assess-home-insights-card">
    <h4 class="intro-header">Introducing</h4>
    <h3 class="title">GyreInsights: Solo Report</h3>
    <p class="intro-text">
      The <a :href="GYREINSIGHTS_LINK">GyreInsights: Solo report</a> resource will provide you with
      real-time observations and suggestions based on your strength mapping and Solo report, saving
      you the time and effort of interpreting it yourself!
    </p>
    <div class="flex-content">
      <div class="flex-item">
        <LottieJyranianWithText width="100%" />
      </div>
      <div class="flex-item">
        <p>Our Jyranians will:</p>
        <ul class="bullet-points">
          <li>Help you think about yourself in terms of your Best-fit Leader types</li>
          <li>
            Guide you through their insights about your personal strengths, considering your
            contribution to your team and your ideal roles.
          </li>
          <li>Help you think about what to develop - close a gap or build on a strength</li>
        </ul>
      </div>
    </div>
    <div class="card-btn-container">
      <a
        :href="GYREINSIGHTS_LINK"
        class="btn btn-primary-forward-bold"
        data-test="assess-home-insights-link"
        >Try it out!</a
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import LottieJyranianWithText from "./lottie/lottie-jyranian-with-text.vue";

const GYREINSIGHTS_LINK = "/resources/session/gyreinsights-your-solo-report";
</script>

<style scoped lang="less">
@import (reference) "../styles/bootstrap/variables";

.card-container {
  background-color: white;
  box-shadow: 1px 1px 15px 5px rgba(238, 238, 238, 0.51);
  padding: 2rem;
}

.intro-header {
  color: @charismatic-color;
  margin-bottom: 0;
}

.title {
  margin-top: 1rem;
}

.intro-text {
  font-size: 16px;
  padding: 1rem 0;
}

.flex-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;
  padding: 1rem 0;

  @media (max-width: @screen-sm-max) {
    flex-direction: column;
  }
}

.flex-item {
  flex-basis: 50%;
}

.lottie-container {
  height: 200px;
  background-color: @off-white;
  margin-right: 2rem;
}

.bullet-points {
  list-style-type: none;
  padding-inline-start: 0;
  text-align: start;
}

li::before {
  content: url("../assets/registration/checkbox-green.svg");
  padding-right: 1rem;
  margin-top: 3px;
}

.bullet-points li {
  padding-bottom: 1rem;
  display: flex;
  color: @text-gray;
}

.card-btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2rem;

  @media (max-width: @screen-sm-max) {
    margin-top: 0;
  }
}
</style>
